// src/pages/TDADMIN.js
import React, { useState } from 'react';
import Layout from '../../components/Layout';
import { getFirestore, doc, updateDoc } from 'firebase/firestore';

const newPADStructure = {
    stageNumber: 4,
        stageTitle: "Post-Assessment Discussion",
        status: "notStarted",
        progress: 0,
        docs_available: false,
        sections: {
            '1': {
                sectionNumber: 1,
                sectionTitle: "Review of Assessment",
                sectionType: "basic",
                status: "notStarted",
                progress: 0,
                route: "/proforma/post-assessment-discussion/review-assessment",
                subsections: {
                    '1': {
                        subsectionNumber: 1,
                        subsectionTitle: "Summary of Assessment Findings",
                        subsectionTitleDisplay: '1.1 Summary of Assessment Findings',
                        hasExamplesOptions: true,
                        examplesOptions: [
                            'Explained the assessment outcome and confirmed the ADHD diagnosis',
                            'Highlighted the benefits of receiving the diagnosis',
                            'Addressed negative feelings related to a late diagnosis',
                            'Validated patient’s experiences and emotional response',
                        ],
                        examplesChecked: null,
                        textBoxSubtitle: "Other or additional comments:",
                        clinicianNotes: null,
                        hasInformationBox: false,
                    },
                    '2': {
                        subsectionNumber: 2,
                        subsectionTitle: "Brief Psychoeducation",
                        subsectionTitleDisplay: '1.2 Brief Psychoeducation',
                        hasExamplesOptions: true,
                        examplesOptions: [
                            'Assessed patient’s understanding of ADHD',
                            'Explained ADHD’s impact on attention, impulsivity, and regulation',
                            'Discussed strengths and challenges, along with external influences on symptoms',
                            'Emphasised that challenges are due to brain differences, not failings',
                            'Reassured on ADHD manageability',
                        ],
                        examplesChecked: null,
                        textBoxSubtitle: "Other or additional comments:",
                        clinicianNotes: null,
                        hasInformationBox: false,
                    },
                    '3': {
                        subsectionNumber: 3,
                        subsectionTitle: "Patient Reflection",
                        subsectionTitleDisplay: '1.3 Patient Reflection',
                        hasExamplesOptions: false,
                        textBoxSubtitle: "Capture the patient's sentiment:",
                        clinicianNotes: null,    
                        hasInformationBox: false,                
                    },
                    '4': {
                        subsectionNumber: 4,
                        subsectionTitle: "Disclosure",
                        subsectionTitleDisplay: '1.4 Disclosure',
                        hasExamplesOptions: true,
                        examplesOptions: [
                            'Explained that sharing an ADHD diagnosis is a personal decision',
                            'Discussed pros and cons of sharing the ADHD diagnosis with employers, family, and friends.',
                            'Emphasised personal comfort and context in disclosure decisions.',
                        ],
                        examplesChecked: null,
                        textBoxSubtitle: "Other or additional comments:",
                        clinicianNotes: null,
                        hasInformationBox: true,
                        informationBoxContent: {
                            "informationBoxTitle": "Pros & Cons of Sharing ADHD Diagnosis",
                            "informationBoxParagraphs": {
                                0: {"header": "With an employer",
                                    "text": "Pros: Support, understanding, potential accommodations, and access to workplace resources. Cons: Risk of stigma, discrimination, privacy concerns, or over-expectation of accommodations."},
                                1: {"header": "With family",
                                    "text": "Pros: Better understanding, empathy, improved relationships, and stronger support systems. Cons: Potential bias, misunderstanding, or conflict with family members."},
                                2: {"header": "With friends",
                                    "text": "Pros: Improved communication, reduced judgment, and stronger support networks. Cons: Risk of stigma, judgment, loss of privacy, or unwanted pressure for support."}
                            }                            
                        },
                    },
                },
            },            
            '2': {
                sectionNumber: 2,
                sectionTitle: "Lifestyle",
                sectionType: "basic",
                status: "notStarted",
                progress: 0,
                route: "/proforma/post-assessment-discussion/lifestyle",
                subsections: {
                    '1': {
                        subsectionNumber: 1,
                        subsectionTitle: "Driving",
                        subsectionTitleDisplay: '2.1 Driving',
                        hasExamplesOptions: true,
                        examplesOptions: [
                            'Reviewed patient’s driving history',
                            'Explained how ADHD can impact on driving',
                            'Advised on the requirement to declare ADHD diagnosis to the DVLA if symptoms or medication affects driving safety',
                        ],
                        examplesChecked: null,
                        textBoxSubtitle: "Tailored recommendations and additional comments:",
                        clinicianNotes: null,
                        hasInformationBox: false,
                    },
                    '2': {
                        subsectionNumber: 1,
                        subsectionTitle: "Lifestyle Factors",
                        subsectionTitleDisplay: '2.2 Lifestyle Factors',
                        hasExamplesOptions: true,
                        examplesOptions: [
                            'Physical activity',
                            'Diet',
                            'Sleep',
                            'Alcohol',
                            'Smoking and/or tobacco use',
                            'Caffeine',
                            'Gambling and/or gaming behaviour',
                            'Substance use',
                            'Financial management',
                            'Stress',
                            'Relationships',
                        ],
                        examplesChecked: null,
                        textBoxSubtitle: "Tailored recommendations and additional comments:",
                        clinicianNotes: null,
                        hasInformationBox: false,
                    },                    
                },
            },
            '3': {
                sectionNumber: 3,
                sectionTitle: "Environment",
                sectionType: "basic",
                status: "notStarted",
                progress: 0,
                route: "/proforma/post-assessment-discussion/environment",
                subsections: {
                    '1': {
                        subsectionNumber: 1,
                        subsectionTitle: "Home",
                        subsectionTitleDisplay: '3.1 Home',
                        hasExamplesOptions: true,
                        examplesOptions: [
                            'Explained that ADHD can make it hard to keep on top of household organisation.',
                            'Discussed the importance of creating a supportive and ADHD-friendly home to reduce stress and enhance daily functioning.',
                            'Recommended strategies to reduce the impact of ADHD symptoms.',
                            'Advised involving family members by educating them about ADHD and encouraging their support in maintaining organisation and respecting quiet or focused time.',
                            'Suggested working with an ADHD coach for personalised strategies to improve home management.',
                            'Recommended contacting an occupational therapist for additional assessment and recommendations for home modifications.',
                        ],
                        examplesChecked: null,
                        textBoxSubtitle: "Tailored recommendations and additional comments:",
                        clinicianNotes: null,
                        hasInformationBox: true,
                        informationBoxContent: {
                            "informationBoxTitle": "Reducing the Impact of ADHD Symptoms at Home",
                            "informationBoxParagraphs": {
                                0: {"header": "",
                                    "text": "- Create a calming environment with quiet areas, reduced clutter, soothing colours, and plants to improve mood and reduce stress."},
                                1: {"header": "",
                                    "text": "- Organise spaces using labelled bins."},
                                2: {"header": "",
                                    "text": "- Designated specific areas for essential items."},
                                3: {"header": "",
                                    "text": "- Keep surfaces like countertops clear to reduce overwhelm."},
                                4: {"header": "",
                                    "text": "- Establish daily routines."},
                                5: {"header": "",
                                    "text": "- Use visual schedules, reminders, timers, alarms, phone notifications, or task management apps."},
                                6: {"header": "",
                                    "text": "- Use whiteboards, calendars, or checklists."},
                                7: {"header": "",
                                    "text": "- Place reminders in prominent locations (e.g., sticky notes on mirrors or doors)."},
                                8: {"header": "",
                                    "text": "- Support sensory regulation with sensory-friendly items like weighted blankets, fidget toys, or adjustable lighting."},
                            }                            
                        },
                    },
                    '2': {
                        subsectionNumber: 2,
                        subsectionTitle: "Employment",
                        subsectionTitleDisplay: '3.2 Employment',
                        hasExamplesOptions: true,
                        examplesOptions: [
                            'Explained that ADHD can create challenges in the workplace.',
                            'Explained that employers are legally required to provide reasonable adjustments for employees with ADHD.',
                            'Recommended contacting Occupational Health services to discuss individual needs and available resources.',
                            'Recommended strategies to reduce the impact of ADHD symptoms.',
                            'Recommended contacting an ADHD coach for support in understanding and coping with ADHD on the job.',
                            'Advised considering an occupational therapist for assessment and recommendations.',
                            'Signposted to Access to Work for support in staying at work.',

                        ],
                        examplesChecked: null,
                        textBoxSubtitle: "Tailored recommendations and additional comments:",
                        clinicianNotes: null,
                        hasInformationBox: true,
                        informationBoxContent: {
                            "informationBoxTitle": "Reducing the Impact of ADHD Symptoms at Work",
                            "informationBoxParagraphs": {                
                                0: {"header": "",
                                    "text": "- Create a quiet workspace."},
                                1: {"header": "",
                                    "text": "- Use noise-cancelling headphones, larger screens, standing desks."},
                                2: {"header": "",
                                    "text": "- Use calendar management tools, website blockers, and visual reminders (e.g., wall charts, checklists, post-it notes)."},
                                3: {"header": "",
                                    "text": "- Develop effective work habits by establishing routines, breaking tasks into smaller steps, and using techniques like the Pomodoro Method (work in timed intervals with breaks)."},
                                4: {"header": "",
                                    "text": "- Ask for flexible working hours."},
                                5: {"header": "",
                                    "text": "- Connect with positive co-workers for support and collaboration."},
                            }                            
                        },
                    },
                    '3': {
                        subsectionNumber: 3,
                        subsectionTitle: "Education",
                        subsectionTitleDisplay: '3.3 Education',
                        hasExamplesOptions: true,
                        examplesOptions: [
                            'Explained that ADHD can impact on learning and academic achievement.',
                            'Explained that universities are legally required to provide reasonable accommodations for students with ADHD.',
                            'Recommended contacting the university’s disability support team to discuss individual needs and explore available resources.',
                            'Recommended strategies to reduce the impact of ADHD symptoms.',
                            'Advised considering an occupational therapist for assessment and recommendations.',
                            'Signposted to Disability Students Allowance for support with study-related costs.',                            
                        ],
                        examplesChecked: null,
                        textBoxSubtitle: "Tailored recommendations and additional comments:",
                        clinicianNotes: null,
                        hasInformationBox: true,
                        informationBoxContent: {
                            "informationBoxTitle": "Reducing the Impact of ADHD Symptoms in Education",
                            "informationBoxParagraphs": {
                                0: {"header": "",
                                    "text": "- Designate quiet study spaces away from distractions."},
                                1: {"header": "",
                                    "text": "- Stay organised with folders, baskets, and colour-coded materials."},
                                2: {"header": "",
                                    "text": "- Use an assignment notebook or digital calendar for task management."},
                                3: {"header": "",
                                    "text": "- Break assignments into smaller chunks and ask for clear instructions."},
                                4: {"header": "",
                                    "text": "- Ask for accommodations like extra time on exams, note-taking help, and study mentors."},
                                5: {"header": "",
                                    "text": "- Paraphrasing instructions received to ensure understanding."},
                                6: {"header": "",
                                    "text": "- Learning note-taking strategies, like using graphic organisers and mind-mapping software."},
                                7: {"header": "",
                                    "text": "- Attend workshops for study skills and time management."},
                            }                            
                        },
                    },
                },
            },
            '4': {
                sectionNumber: 4,
                sectionTitle: "Treatment Options",
                sectionType: "treatment_planning",
                status: "notStarted",
                progress: 0,
                route: "/proforma/post-assessment-discussion/treatment-options",
                subsections: {
                    '1': {
                        subsectionNumber: 1,
                        subsectionTitle: "Patient’s Goals",
                        subsectionTitleDisplay: '4.1 Patient’s Goals',
                        hasInformationBox: false,
                        questions: {
                                    '1' : {
                                        questionNumber: 1,
                                        questionTitle: "Please detail the patient's goals for treatment:",
                                        questionType: "clinicianNotes",
                                        clinicianNotes: null,
                                        firestoreFieldName: "patientsGoalsClinicianNotes",
                                    },                
                                },
                    },
                    '2': {
                        subsectionNumber: 2,
                        subsectionTitle: "Patient’s Treatment Preferences",
                        subsectionTitleDisplay: '4.2 Patient’s Treatment Preferences', 
                        hasInformationBox: false,
                        questions: {
                            '1' : {
                                questionNumber: 1,
                                questionTitle: "Have pharmacological treatment options been discussed?",
                                questionType: "singleSelectDropdown",
                                optionsButtons: [
                                    "Yes",
                                    "No"
                                ],
                                required: true,
                                firestoreFieldName: "pharmacologicalTreatmentDiscussed",                                                                                  
                            },
                            '2' : {
                                questionNumber: 2,
                                questionTitle: "Have non-pharmacological treatment options been discussed?",
                                questionType: "singleSelectDropdown",
                                optionsButtons: [
                                    "Yes",
                                    "No"
                                ],
                                required: true,
                                firestoreFieldName: "nonPharmacologicalTreatmentDiscussed",                                                                                  
                            }, 
                            '3' : {
                                questionNumber: 3,
                                questionTitle: "What are the patient's preferences for treatment?",
                                questionType: "singleSelectDropdown",
                                optionsButtons: [
                                    "Pharmacological treatment only", 
                                    "Non-pharmacological treatment only",
                                    "Both Pharmacological and Non-pharmacological treatment",
                                    "No treatment",
                                ],
                                firestoreFieldName: "patientTreatmentPreferences",                                                                                  
                            },
                            '4' : {
                                questionNumber: 4,
                                questionTitle: "Please provide details of non-pharmacological treatment options to be trialled:",
                                questionType: "freeTextBox",                                
                                showIf: {
                                    0: {"firestoreFieldName": "patientTreatmentPreferences", "optionSelected": "Non-pharmacological treatment only"},
                                },
                                firestoreFieldName: "nonPharmOnlyClinicianNotes",                                                    
                            },   
                            '5' : {
                                questionNumber: 5,
                                questionTitle: "Please provide details of non-pharmacological treatment options to be trialled:",
                                questionType: "freeTextBox",                                
                                showIf: {
                                    0: {"firestoreFieldName": "patientTreatmentPreferences", "optionSelected": "Both Pharmacological and Non-pharmacological treatment"},
                                },
                                firestoreFieldName: "nonPharmAndPharmClinicianNotes",                                                    
                            },  
                            '6' : {
                                questionNumber: 6,
                                questionTitle: "Please provide details about preference of no treatment:",
                                questionType: "freeTextBox",                                
                                showIf: {
                                    0: {"firestoreFieldName": "patientTreatmentPreferences", "optionSelected": "No treatment"},
                                },
                                firestoreFieldName: "noTreatmentClinicianNotes",                                                    
                            },             
                        },
                    },
                    '3': {
                        subsectionNumber: 3,
                        subsectionTitle: "Physical Health Review",
                        subsectionTitleDisplay: '4.3 Physical Health Review',
                        hasInformationBox: false, 
                        questions: {
                            '1' : {
                                    questionNumber: 1,
                                    questionTitle: "Is blood pressure available?",
                                    questionType: "singleSelectDropdown",
                                    optionsButtons: [
                                        "Yes", 
                                        "No",
                                    ],
                                    otherOptions: {
                                        0: {"option": "No", placeholderText: "Blood pressure reading required before commencing treatment.", textBoxDisabled: true},
                                    },
                                    firestoreFieldName: "isBloodPressureAvailable",                                                                                      
                                },
                            '2' : {
                                questionNumber: 2,
                                questionTitle: "Please input blood pressure measurements:",
                                questionType: "freeTextBox",                                
                                showIf: {
                                    0: {"firestoreFieldName": "isBloodPressureAvailable", "optionSelected": "Yes"},
                                },
                                firestoreFieldName: "bpMeasurementsClinicianNotes",
                            },
                            '3' : {
                                questionNumber: 3,
                                questionTitle: "Is blood pressure within normal range?",
                                questionType: "singleSelectDropdown",
                                optionsButtons: [
                                    "Yes", 
                                    "No - Hypertensive",
                                    "No - Hypotensive",
                                    "No - other reason",
                                ],                                
                                showIf: {
                                    0: {"firestoreFieldName": "isBloodPressureAvailable", "optionSelected": "Yes"},
                                },
                                firestoreFieldName: "isBloodPressureRangeNormal",                                                                                      
                            },  
                            '4' : {
                                questionNumber: 4,
                                questionTitle: "Please provide details of blood pressure range abnormality:",
                                questionType: "freeTextBox",
                                firestoreFieldName: "bpAbnormalityClinicianNotes",
                                showIf: {
                                    0: {"firestoreFieldName": "isBloodPressureRangeNormal", "optionSelected": "No - other reason"},
                                }
                            },
                            '5' : {
                                    questionNumber: 5,
                                    questionTitle: "Is pulse available?",
                                    questionType: "singleSelectDropdown",
                                    optionsButtons: [
                                        "Yes", 
                                        "No",
                                    ],
                                    otherOptions: {
                                        0: {"option": "No", placeholderText: "Pulse reading required before commencing treatment.", textBoxDisabled: true},                                       
                                    },
                                    firestoreFieldName: "isPulseAvailable",
                                },
                            '6' : {
                                questionNumber: 6,
                                questionTitle: "Please input pulse measurements:",
                                questionType: "freeTextBox",
                                firestoreFieldName: "pulseMeasurementsClinicianNotes",
                                showIf: {
                                    0: {"firestoreFieldName": "isPulseAvailable", "optionSelected": "Yes"},
                                }
                            },
                            '7' : {
                                questionNumber: 7,
                                questionTitle: "Is pulse within normal range?",
                                questionType: "singleSelectDropdown",
                                optionsButtons: [
                                    "Yes", 
                                    "No - Arrhythmic (ECG recommended)",
                                    "No - Tachycardic (ECG recommended)",
                                    "No - other reason",
                                ],                               
                                showIf: {
                                    0: {"firestoreFieldName": "isPulseAvailable", "optionSelected": "Yes"},
                                },
                                firestoreFieldName: "isPulseNormal",                                                                                      
                            },
                            '8' : {
                                questionNumber: 8,
                                questionTitle: "Please provide details of pulse abnormality:",
                                questionType: "freeTextBox",
                                firestoreFieldName: "pulseAbnormalityClinicianNotes",
                                showIf: {
                                    0: { "firestoreFieldName": "isPulseNormal", "optionSelected": "No - other reason"},
                                },
                            },
                            '9' : {
                                questionNumber: 9,
                                questionTitle: "Body Mass Index (BMI)",
                                questionType: "customLogicBMI",                                
                            },                            
                        }
                    },  
                    '4': {
                        subsectionNumber: 4,
                        subsectionTitle: "Medical History Review",
                        subsectionTitleDisplay: '4.4 Medical History Review',
                        hasInformationBox: false, 
                        questions: {
                            '1' : {
                                    questionNumber: 1,
                                    questionTitle: "Are contraindications to pharmacological treatment present?",
                                    questionType: "singleSelectDropdown",
                                    optionsButtons: [
                                        "Contraindications identified", 
                                        "No contraindications identified",
                                        "More information required"
                                    ],                                    
                                    required: true,
                                    firestoreFieldName: "areContraindicationsPresent",                                                                                      
                                }, 
                            '2' : {
                                questionNumber: 2,
                                questionTitle: "Please provide details of contraindications:",
                                questionType: "freeTextBox",                                
                                showIf: {
                                    0: { "firestoreFieldName": "areContraindicationsPresent", "optionSelected": "Contraindications identified"},
                                },
                                firestoreFieldName: "contraindicationsIdentifiedClinicianNotes",
                            },
                            '3' : {
                                questionNumber: 3,
                                questionTitle: "Please provide details of what further information is required:",
                                questionType: "freeTextBox",                                
                                showIf: {
                                    0: { "firestoreFieldName": "areContraindicationsPresent", "optionSelected": "More information required"},
                                },
                                firestoreFieldName: "contraindicationsMoreInfoRequiredClinicianNotes",
                            },
                                '4' : {
                                    questionNumber: 4,
                                    questionTitle: "For pregnant or breastfeeding patients only, is the patient still proceeding with ADHD medication following a risk-benefit analysis?",
                                    questionType: "singleSelectDropdown",
                                    optionsButtons: [
                                        "Yes", 
                                        "No - defer",
                                    ],                                    
                                    required: false,
                                    firestoreFieldName: "isProceedingAfterPregnancyRiskAssessment",
                                },   
                                '5' : {
                                questionNumber: 5,
                                questionTitle: "Please provide details of deferral decision, including any relevant outcomes of risk-benefit analysis:",
                                questionType: "freeTextBox",                                
                                showIf: {
                                    0: { "firestoreFieldName": "isProceedingAfterPregnancyRiskAssessment", "optionSelected": "No - defer"},
                                },
                                firestoreFieldName: "pregnancyImpactClinicianNotes",
                            },                                             
                        }
                    },  
                    '5': {
                        subsectionNumber: 5,
                        subsectionTitle: "Cardiovascular Risk Assessment",
                        subsectionTitleDisplay: '4.5 Cardiovascular Risk Assessment',
                        questions: {
                            '1' : {
                                    questionNumber: 1,
                                    questionTitle: "Is an ECG required?",
                                    questionType: "singleSelectDropdown",
                                    optionsButtons: [
                                        "No - ECG not required",
                                        "Yes - ECG required",                                     
                                        "Refer for cardiology opinion",
                                    ],                                    
                                    required: true,
                                    firestoreFieldName: "isECGrequired",
                                },
                            '2' : {
                                questionNumber: 2,
                                questionTitle: "Please provide rationale for ECG being required:",
                                questionType: "freeTextBox",                                
                                showIf: {
                                    0: {"firestoreFieldName": "isECGrequired", "optionSelected": "Yes - ECG required"},
                                },
                                firestoreFieldName: "ecgRequirementClinicianNotes",
                            },
                            '3' : {
                                questionNumber: 3,
                                questionTitle: "Please provide details of referral for cardiology opinion:",
                                questionType: "freeTextBox",                                
                                showIf: {
                                    0: {"firestoreFieldName": "isECGrequired", "optionSelected": "Refer for cardiology opinion"},
                                },
                                firestoreFieldName: "referForCardiologyOpinionClinicianNotes",
                            },
                        },
                        hasInformationBox: true,
                        informationBoxContent: {
                            "informationBoxTitle": "",
                            "informationBoxParagraphs": {
                                0: {"header": "An ECG is required if any of the following are present",
                                    "text": "- Family history or medical history of serious cardiac disease"},
                                1: {"header": "",
                                    "text": "- Family history of early cardiac death"},        
                                2: {"header": "",
                                    "text": "- Abnormal findings on cardiac examination"},
                                3: {"header": "",
                                    "text": "- Treatment with other medications with potential for QTc prolongation"},
                                4: {"header": "Refer for cardiology opinion if any of the following apply:",
                                    "text": "- History of congenital heart disease or previous cardiac surgery"},
                                5: {"header": "",
                                    "text": "- History of sudden death in a first-degree relative under 40 years suggesting a cardiac disease"},        
                                6: {"header": "",
                                    "text": "- Shortness of breath on exertion compared with peers"},
                                7: {"header": "",
                                    "text": "- Fainting on exertion or in response to fright or noise"},
                                8: {"header": "",
                                    "text": "- Palpitations that are rapid, regular and start and stop suddenly"},
                                9: {"header": "",
                                    "text": "- Chest pain suggesting cardiac origin"},
                                10: {"header": "",
                                    "text": "- Signs of heart failure"},
                                11: {"header": "",
                                    "text": "- A murmur heard on cardiac examination"},
                                12: {"header": "",
                                    "text": "- Blood pressure that is classified as hypertensive for adults"},
                            }                            
                        },                        
                    },  
                    '6': {
                        subsectionNumber: 6,
                        subsectionTitle: "Drug Diversion Risk Assessment",
                        subsectionTitleDisplay: '4.6 Drug Diversion Risk Assessment',
                        questions: {
                            '1' : {
                                    questionNumber: 1,
                                    questionTitle: "Having conducted a risk assessment, is the patient still proceeding with ADHD medication?",
                                    questionType: "singleSelectDropdown",
                                    optionsButtons: [
                                        "Yes",
                                        "No - risks identified",
                                    ],                                    
                                    required: true,
                                    firestoreFieldName: "isProceedingAfterDrugDiversionRiskAssessment",
                                },
                                '2' : {
                                questionNumber: 2,
                                questionTitle: "Please provide details of decision, including any risks identified:",
                                questionType: "freeTextBox",
                                firestoreFieldName: "drugDiversionRisksClinicianNotes",
                                showIf: {
                                    0: {"firestoreFieldName": "isProceedingAfterDrugDiversionRiskAssessment", "optionSelected": "No - risks identified"},
                                }
                            },                            
                        },
                        hasInformationBox: true,
                        informationBoxContent: {
                            "informationBoxTitle": "Risk Factors for Drug Diversion",
                            "informationBoxParagraphs": {
                                0: {"header": "",
                                    "text": "- History of substance misuse or addiction."},
                                1: {"header": "",
                                    "text": "- Current use of substances."},
                                2: {"header": "",
                                    "text": "- Family history of substance misuse or addiction."},
                                3: {"header": "",
                                    "text": "- Previous mental health issues associated with substance use."},
                                4: {"header": "",
                                    "text": "- Co-prescribed medications that may increase the potential for misuse (e.g., opioids, benzodiazepines)."},
                                5: {"header": "",
                                    "text": "- Current involvement with substance misuse services."},
                            }                                          
                        },
                    },
                    '7': {
                        subsectionNumber: 7,
                        subsectionTitle: "Outcome of Health Checks",
                        subsectionTitleDisplay: '4.7 Outcome of Health Checks',
                        questions: {
                            '1' : {
                                questionNumber: 1,
                                questionTitle: "Following comprehensive assessment, is patient proceeding with pharmacological treatment?",
                                questionType: "singleSelectDropdown",
                                optionsButtons: [
                                    "Yes", 
                                    "No - more information needed or risks identified"
                                ],   
                                required: true,  
                                firestoreFieldName: "isProceedingAfterFullAssessment",                                                
                            },
                            '2' : {
                                questionNumber: 2,
                                questionTitle: "Please provide details of decision:",
                                questionType: "freeTextBox",
                                firestoreFieldName: "notProceedingAfterFullAssessmentClinicianNotes",
                                showIf: {
                                    0: {"firestoreFieldName": "isProceedingAfterFullAssessment", "optionSelected": "No - more information needed or risks identified"},
                                }
                            },
                            '3' : {
                                questionNumber: 3,
                                questionTitle: "Is patient beginning medication now?",
                                questionType: "singleSelectDropdown",
                                optionsButtons: [
                                    "Yes - proceed to Medication Plan", 
                                    "No - refer on to titration",
                                    "No - defer"
                                ],
                                otherOptions: {
                                    0: {"option": "No - refer on to titration", placeholderText: "Patient will be referred for initiation of treatment and titration.", textBoxDisabled: true},                                                                                                                                                       
                                },
                                required: true,   
                                showIf: {
                                    0: {"firestoreFieldName": "isProceedingAfterFullAssessment", "optionSelected": "Yes"},
                                },
                                firestoreFieldName: "isBeginningMedicationNow",
                            },
                            '4' : {
                                questionNumber: 4,
                                questionTitle: "Please provide details of deferral:",
                                questionType: "freeTextBox",                                
                                required: true,  
                                showIf: {
                                    0: {"firestoreFieldName": "isBeginningMedicationNow", "optionSelected": "No - defer"},
                                },
                                firestoreFieldName: "deferralReasonClinicianNotes",
                            },
                        },
                        hasInformationBox: false,                        
                    },
                },                
            },
            '5': {
                sectionNumber: 5,
                sectionTitle: "Agreed Medication Plan",
                sectionType: "agreed_medication_plan",
                status: "notStarted",
                progress: 0,
                route: "/proforma/post-assessment-discussion/agreed-medication-plan",
                subsections: {
                    '1': {
                        subsectionNumber: 1,
                        subsectionTitle: "Medication Plan Details",
                        subsectionTitleDisplay: '5.1 Medication Plan Details',
                        hasInformationBox: false,
                        questions: {     
                            '1' : {
                                questionNumber: 1,
                                questionTitle: "Stimulant or Non-stimulant",
                                instructionText: "Indicate whether the medication is a stimulant or non-stimulant.",
                                questionType: "singleSelectDropdown",
                                optionsButtons: [
                                    "Stimulant", 
                                    "Non-stimulant",
                                ], 
                                required: true,  
                                firestoreFieldName: "stimulantOrNonStimulant",                
                            },
                            '2' : {
                                questionNumber: 2,
                                questionTitle: "Formulation",
                                instructionText: "Specify whether the medication is an extended-release (ER) or immediate-release (IR) formulation.",
                                questionType: "singleSelectDropdown",
                                optionsButtons: [
                                    "Extended-release (ER)", 
                                    "Immediate-release (IR)",
                                    "N/A"
                                ], 
                                required: true,     
                                firestoreFieldName: "formulation",             
                            },
                            '3' : {
                                questionNumber: 3,
                                questionTitle: "Medication Name",
                                instructionText: 'Provide the full name of the medication, including the specific brand or generic name (e.g., "Elvanse Adult" or "Concerta XL" or "methylphenidate").',
                                questionType: "freeTextBox",
                                required: true,       
                                firestoreFieldName: "medicationName",           
                            },    
                            '4' : {
                                questionNumber: 4,
                                questionTitle: "Starting Dose",
                                instructionText: 'Enter the starting dose of the medication, ensuring you include the unit of measurement (e.g., "20mg" or "30mg").',
                                questionType: "freeTextBox",
                                required: true,
                                firestoreFieldName: "startingDose",                  
                            },    
                            '5' : {
                                questionNumber: 5,
                                questionTitle: "Frequency",
                                instructionText: 'Specify how often the medication should be taken, including the number of times per day (e.g., "2 times a day" or "once a day").',
                                questionType: "freeTextBox",
                                required: true,     
                                firestoreFieldName: "frequency",             
                            },    
                            '6' : {
                                questionNumber: 6,
                                questionTitle: "Review Schedule",
                                instructionText: 'Please indicate the frequency of follow-up reviews, including the date of the next scheduled follow-up if available (e.g., "Every 3 weeks, next review on 3rd March, 2025").',
                                questionType: "freeTextBox",
                                required: true,     
                                firestoreFieldName: "reviewSchedule",             
                            },    
                        },
                    },
                    '2': {
                        subsectionNumber: 2,
                        subsectionTitle: "Informed Consent",
                        subsectionTitleDisplay: '5.2 Informed Consent',
                        hasInformationBox: false,
                        questions: {       
                            '1' : {
                                questionNumber: 1,
                                questionTitle: "Information to be shared with patient",
                                questionType: "checkboxes",
                                checkboxOptions: [
                                    "(If relevant re: off-label use) Patient has been informed that the chosen medication is not licenced for use in adults.",
                                    "Patient has been informed of common side effects of the chosen medication"
                                ],
                                required: false,
                                firestoreFieldName: "informedConsent",      
                            },    
                        },
                    },
                },
            },
        },
};



    function AdminTD() {
        const [uuid, setUuid] = useState('');
        const [logMessages, setLogMessages] = useState([]);
        const [successMessage, setSuccessMessage] = useState('');
      
        const updateFirestoreDocument = async () => {
          if (!uuid) {
            setLogMessages((prev) => [...prev, 'Please enter a valid UUID.']);
            return;
          }
      
          const db = getFirestore();
          const docRef = doc(db, 'patients', uuid);
      
          try {
            setLogMessages((prev) => [...prev, 'Starting update...']);
            await updateDoc(docRef, {
              'dataModel.5_postAssessmentDiscussion': newPADStructure
            });
            setLogMessages((prev) => [...prev, 'Document successfully updated!']);
            setSuccessMessage('Update completed successfully!');
          } catch (error) {
            setLogMessages((prev) => [...prev, `Error updating document: ${error.message}`]);
          }
        };

  return (
    <Layout activePage="analytics">
      <div className="flex-grow p-8 flex items-center justify-center">
        <div className="bg-gray-100 p-8 rounded-lg shadow-md w-full max-w-2xl">
          <h2 className="text-2xl font-bold mb-6 text-center">ThinkDivergent Admin</h2>
          <p className="text-center text-gray-700">
          <div>
          <label htmlFor="uuid">Enter Patient UUID:</label>
        <input
          type="text"
          id="uuid"
          value={uuid}
          onChange={(e) => setUuid(e.target.value)}
          placeholder="Enter UUID"
          className="border border-gray-300 rounded-md p-2"
        />
      </div>
      <button onClick={updateFirestoreDocument}>
        Update Post-Assessment Discussion
      </button>
      <div>
        <h2>Logs:</h2>
        <ul>
          {logMessages.map((msg, index) => (
            <li key={index}>{msg}</li>
          ))}
        </ul>
      </div>
      {successMessage && <div style={{ color: 'green' }}>{successMessage}</div>}
          </p>
        </div>
      </div>
      </Layout>
  );
}

export default AdminTD;